import React from "react";
import { Field } from "./editorShared";
import AddressFields from "../AddressFields";
import ClientPicker from "./ClientPicker";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export default function ClientSection({ q, setClient }) {
  return (
    <section className="bg-card border border-slate-200/80 rounded-xl p-6 shadow-sm">
      <h2 className="text-base font-semibold text-slate-900 mb-5">Dati Cliente</h2>
      <ClientPicker onPick={(c) => Object.entries(c).forEach(([k, v]) => setClient(k, v))} />
      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Nome / Azienda">
          <Input data-testid="quote-editor-client-name-input" value={q.client.name} onChange={(e) => setClient("name", e.target.value)} />
        </Field>
        <Field label="Email">
          <Input data-testid="quote-editor-client-email-input" type="email" value={q.client.email} onChange={(e) => setClient("email", e.target.value)} />
        </Field>
        <Field label="Telefono / WhatsApp">
          <Input data-testid="quote-editor-client-phone-input" value={q.client.phone || ""} onChange={(e) => setClient("phone", e.target.value)} placeholder="+39 333 1234567" />
        </Field>
        <Field label="P.IVA / CF">
          <Input value={q.client.vat} onChange={(e) => setClient("vat", e.target.value)} />
        </Field>
      </div>
      <div className="mt-5">
        <AddressFields value={q.client} onChange={setClient} testidPrefix="quote-editor-client" />
      </div>
      <Field label="Tipo Cliente" className="mt-5">
        <Select value={q.client.type || "business"} onValueChange={(v) => setClient("type", v)}>
          <SelectTrigger data-testid="quote-editor-client-type"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="business">Azienda o professionista sostituto d'imposta (applica la ritenuta)</SelectItem>
            <SelectItem value="business_nosost">Azienda o professionista non sostituto d'imposta (es. forfettario)</SelectItem>
            <SelectItem value="private">Privato / Estero</SelectItem>
          </SelectContent>
        </Select>
      </Field>
    </section>
  );
}
